var map = {
	"./bs_web_lace_base01_.png": 427980,
	"./bs_web_lace_base01_blk.png": 951243,
	"./bs_web_lace_base01_blu.png": 93525,
	"./bs_web_lace_base01_cho.png": 874114,
	"./bs_web_lace_base01_cml.png": 708090,
	"./bs_web_lace_base01_crk.png": 589088,
	"./bs_web_lace_base01_dor.png": 706941,
	"./bs_web_lace_base01_grn.png": 360225,
	"./bs_web_lace_base01_gry.png": 503902,
	"./bs_web_lace_base01_lmn.png": 869807,
	"./bs_web_lace_base01_nvy.png": 271639,
	"./bs_web_lace_base01_orn.png": 741753,
	"./bs_web_lace_base01_pnk-.png": 287166,
	"./bs_web_lace_base01_pnk.png": 83971,
	"./bs_web_lace_base01_red.png": 161583,
	"./bs_web_lace_base01_sbu.png": 774286,
	"./bs_web_lace_base01_wbk.png": 59644,
	"./bs_web_lace_base01_wch.png": 984012,
	"./bs_web_lace_base01_wht.png": 51301,
	"./bs_web_lace_base01_wpl.png": 215509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81787;